import { useState } from "react";
import api, { errorMessage } from "../lib/api";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import {
    Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle, DialogDescription,
} from "./ui/dialog";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export const ChangeMyPasswordModal = ({ open, onOpenChange }) => {
    const [currentPw, setCurrentPw] = useState("");
    const [newPw, setNewPw] = useState("");
    const [confirmPw, setConfirmPw] = useState("");
    const [submitting, setSubmitting] = useState(false);

    const reset = () => {
        setCurrentPw(""); setNewPw(""); setConfirmPw("");
    };

    const submit = async () => {
        if (!currentPw || !newPw) return toast.error("Password lama & baru wajib diisi");
        if (newPw.length < 6) return toast.error("Password baru minimal 6 karakter");
        if (newPw !== confirmPw) return toast.error("Konfirmasi password tidak cocok");
        setSubmitting(true);
        try {
            await api.post("/account/change-my-password", {
                current_password: currentPw,
                new_password: newPw,
            });
            toast.success("Password berhasil diubah");
            reset();
            onOpenChange(false);
        } catch (e) {
            toast.error(errorMessage(e));
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Dialog open={open} onOpenChange={(o) => { if (!o) reset(); onOpenChange(o); }}>
            <DialogContent className="rounded-xl max-w-md" data-testid="change-my-password-modal">
                <DialogHeader>
                    <DialogTitle>Ubah Password Saya</DialogTitle>
                    <DialogDescription>
                        Masukkan password lama lalu password baru minimal 6 karakter.
                    </DialogDescription>
                </DialogHeader>
                <div className="space-y-4 py-2">
                    <div>
                        <Label>Password Lama</Label>
                        <Input
                            type="password"
                            value={currentPw}
                            onChange={(e) => setCurrentPw(e.target.value)}
                            data-testid="change-pw-current-input"
                            className="mt-1.5 rounded-lg"
                            placeholder="••••••••"
                        />
                    </div>
                    <div>
                        <Label>Password Baru</Label>
                        <Input
                            type="password"
                            value={newPw}
                            onChange={(e) => setNewPw(e.target.value)}
                            data-testid="change-pw-new-input"
                            className="mt-1.5 rounded-lg"
                            placeholder="Min. 6 karakter"
                        />
                    </div>
                    <div>
                        <Label>Konfirmasi Password Baru</Label>
                        <Input
                            type="password"
                            value={confirmPw}
                            onChange={(e) => setConfirmPw(e.target.value)}
                            data-testid="change-pw-confirm-input"
                            className="mt-1.5 rounded-lg"
                            placeholder="Ulangi password baru"
                        />
                    </div>
                </div>
                <DialogFooter>
                    <Button
                        variant="outline"
                        onClick={() => { reset(); onOpenChange(false); }}
                        className="rounded-lg"
                        data-testid="change-pw-cancel-button"
                    >
                        Batal
                    </Button>
                    <Button
                        onClick={submit}
                        disabled={submitting}
                        data-testid="change-pw-submit-button"
                        className="rounded-lg text-white"
                        style={{ background: "var(--apple-blue)" }}
                    >
                        {submitting ? (
                            <><Loader2 className="w-4 h-4 mr-2 animate-spin" /> Menyimpan...</>
                        ) : "Simpan"}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};
